import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { withRights } from 'providers/RightsConsumer';
import DocumentVerificationSummaryModal from './DocumentVerificationSummaryModal';
import { getVerificationDocumentDetails, disableDownload } from '../common/functions';
import { DownloadClickWrapper, StatusTableCell, SummaryClickWrapper, VerificationTableContainerWrapper } from '../VerificationStyles';

const DocumentVerificationComponent = ({ data, t, rights, showSensitiveInfoError, downloadFile }) => {
  const [verificationSummaryModalOpen, setVerificationSummaryModal] = useState(false);
  const [verificationSummaryModalIndex, setVerificationSummaryModalIndex] = useState(-1);

  const toggleVerificationSummaryModal = index => {
    setVerificationSummaryModal(!verificationSummaryModalOpen);
    setVerificationSummaryModalIndex(index);
  };

  const onDownloadClick = (event, item) => {
    if (disableDownload(item, rights)) {
      showSensitiveInfoError();
      return;
    }

    event.preventDefault();
    downloadFile(item.sharepointUniqueId);
  };

  const renderItem = (item, index) => {
    return (
      <TableRow key={item.verificationId}>
        {!rights.readOnlyFull && item.sharepointUniqueId && item.fileNameFormat && rights.clientVerificationsWrite ? (
          <TableCell>
            {item.viewReport === true ? (
              <DownloadClickWrapper disabled onClick={e => onDownloadClick(e, item)}>
                {item.verificationType}
              </DownloadClickWrapper>
            ) : (
              item.verificationType
            )}
          </TableCell>
        ) : (
          <TableCell>{item.verificationType}</TableCell>
        )}
        <TableCell>
          {`${item.partnerName} 
             ${getVerificationDocumentDetails(item)}`}
        </TableCell>
        <StatusTableCell statusCode={item.statusCode}>{item.status}</StatusTableCell>
        <TableCell>{item.user}</TableCell>
        <TableCell>{t('DATE', { date: item.date })}</TableCell>
        <TableCell>{t('DATE', { date: item.validityDate })}</TableCell>
        <TableCell>
          {item.viewSummary === true ? (
            <SummaryClickWrapper onClick={() => toggleVerificationSummaryModal(index)}>{item.summaryTitle || ''}</SummaryClickWrapper>
          ) : (
            item.summaryTitle || ''
          )}
        </TableCell>
        <TableCell>
          {item.messageCode ? (
            item.messageCode
          ) : (
            <div>
              {item.comments?.split('\n').map((item, key) => {
                return <div key={key}>{item}</div>;
              })}
            </div>
          )}
        </TableCell>
      </TableRow>
    );
  };

  return (
    <>
      <VerificationTableContainerWrapper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('DocumentEdit.Verification.Type')}</TableCell>
              <TableCell>{t('DocumentEdit.Verification.Entity')}</TableCell>
              <TableCell>{t('DocumentEdit.Verification.State')}</TableCell>
              <TableCell>{t('DocumentEdit.Verification.User')}</TableCell>
              <TableCell>{t('DocumentEdit.Verification.Date')}</TableCell>
              <TableCell>{t('DocumentEdit.Verification.ValidityDate')}</TableCell>
              <TableCell>{t('DocumentEdit.Verification.SummaryTitle')}</TableCell>
              <TableCell>{t('DocumentEdit.Verification.Comments')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{data && data.map(renderItem)}</TableBody>
        </Table>
      </VerificationTableContainerWrapper>
      {verificationSummaryModalOpen && (
        <DocumentVerificationSummaryModal
          verificationSummaryModalOpen={verificationSummaryModalOpen}
          closeVerificationSummaryModal={toggleVerificationSummaryModal}
          summary={data && data[verificationSummaryModalIndex]?.summary?.replace(/(?:\r\n|\r|\n)/g, '<br>')}
        />
      )}
    </>
  );
};

DocumentVerificationComponent.propTypes = {
  data: PropTypes.array,
  t: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired,
  downloadFile: PropTypes.func.isRequired,
  showSensitiveInfoError: PropTypes.func.isRequired
};

export default compose(withTranslation())(withRights(DocumentVerificationComponent));
